var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayed)?_c('Tree',{ref:"tree",attrs:{"options":_vm.treeOptions},on:{"node:selected":_vm.itemSelected},scopedSlots:_vm._u([{key:"default",fn:function({ node }){return [_c('span',[_c('i',{class:`fas ${_vm.iconClass(node.states.type)}`}),_vm._v("\n      "+_vm._s(node.text)+"\n    ")])]}}],null,false,1704839089)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }